import React from "react";
import { Helmet } from "react-helmet";

import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";

const Meta = () => {
  return (
    <Helmet>
      <title>Terms & Conditions - FuelCab India</title>
      <meta
        name="description"
        content="Discover FuelCab, a leading provider of on-demand fuel delivery services. Learn about our mission, values, achievements, and global presence."
      />
      <meta
        name="keywords"
        content="FuelCab, on-demand fuel delivery, fuel management, fuel delivery services, mission, values, achievements, global presence"
      />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta name="robots" content="index, follow" />
      <script type="application/ld+json">
        {`{
            "@context": "https://schema.org",
            "@type": "Organization",
            url: "https://www.fuelcab.com/term-policy",
            name: "FuelCab",
            description:
              "FuelCab is a leading provider of on-demand fuel delivery services. We are dedicated to making fuel management easy and convenient for our customers.",
          }`}
      </script>
    </Helmet>
  );
};

const TermPolicy = () => {
  return (
    <>
      <Meta />
      <Navbar />
      <section className="font-dmsans w-full bg-[#F7F8FA] pb-7">
        <div className="w-full text-center md:px-[32px] px-6 py-12 border border-y-neutral-300">
          <h1 className="text-[1.75rem] font-semibold leading-[36px] text-[#424242]">
            TERMS AND CONDITIONS
          </h1>
        </div>
        <div className="md:mx-[10rem] mx-6 my-7 bg-white border border-neutral-300">
          <div className="py-14">
            <h3 className="text-center ">Terms and Conditions</h3>
            <h4 className="text-center font-semibold pt-4">
              Last updated: 05<sup>th</sup> March 2024
            </h4>
          </div>
          <section className="flex justify-start items-start">
            <div className="md:px-16 px-4">
              <div className="w-full flex flex-col items-start">
                <div className="my-2 w-full h-full flex">
                  <div className="flex flex-col items-start">
                    <h2 className=" font-[700]">
                      For the purposes of these Terms and Conditions:
                    </h2>
                    <ul className="flex flex-col items-start w-full mt-4">
                      <li>
                        <p classname="text-sm">
                          1."Affiliate" means an entity that controls, is
                          controlled by or is under common control with a party,
                          where "control" means ownership of 50% or more of the
                          shares, equity interest or other securities entitled
                          to vote for election of directors or other managing
                          authority.
                        </p>
                      </li>
                      <li>
                        <p classname="text-sm my-2">
                          2."Account" means a unique account created for You to
                          access our Service or parts of our Service.
                        </p>
                      </li>
                      <li>
                        <p classname="text-sm my-2">
                          3."Company" (referred to as either "the Company",
                          "We", "Us" or "Our" in this Agreement) refers to
                          Triple S fuelcab Business Solutions LLP, a limited
                          liability partnership firm registered under the
                          Limited Liability Partnership Act, 2008 having its
                          registered office at Ground Floor 272, Green Park
                          Rampur Chungi, Rampur Urban Roorkee, Haridwar
                          Uttarakhand-247687.
                        </p>
                      </li>
                      <li>
                        <p classname="text-sm my-2">
                          4."Country" refers to Fuelcab.
                        </p>
                      </li>
                      <li>
                        <p classname="text-sm my-2">
                          5."Content" refers to content such as text, images, or
                          other information that can be posted, uploaded, linked
                          to or otherwise made available by You, regardless of
                          the form of that content.
                        </p>
                      </li>
                      <li>
                        <p classname="text-sm my-2">
                          6."Device" means any device that can access the
                          Service such as a computer, a cellphone or a digital
                          tablet.
                        </p>
                      </li>
                      <li className>
                        <p classname="text-sm my-2">
                          7."Feedback" means feedback, innovations or
                          suggestions sent by You regarding the attributes,
                          performance or features of our Service.
                        </p>
                      </li>
                      <li className>
                        <p classname="text-sm my-2">
                          8."Service" refers to the Website.
                        </p>
                      </li>
                      <li className>
                        <p classname="text-sm my-2">
                          9."Terms and Conditions" mean these Terms and
                          Conditions that form the entire agreement between You
                          and the Company regarding the use of the Service.
                        </p>
                      </li>
                      <li className>
                        <p classname="text-sm my-2">
                          10."Third-party Social Media Service" means any
                          services or content (including data, information,
                          products or services) provided by a third-party that
                          may be displayed, included or made available by the
                          Service.
                        </p>
                      </li>
                      <li>
                        <p classname="text-sm my-2">
                          11."Website" refers to Fuelcab, accessible from
                          <a href="https://www.fuelcab.com/">Fuelcab</a>
                        </p>
                      </li>
                      <li>
                        <p classname="text-sm my-2">
                          12."You" means the individual accessing or using the
                          Service, or the company, or other legal entity on
                          behalf of which such individual is accessing or using
                          the Service, as applicable.
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="flex mt-2 items-center">
                  <div className=" w-full">
                    <h2 className=" font-[700] mb-4">Acknowledgment</h2>
                    <p classname="text-sm">
                      These are the Terms and Conditions governing the use of
                      this Service and the agreement that operates between You
                      and the Company. These Terms and Conditions set out the
                      rights and obligations of all users regarding the use of
                      the Service. Your access to and use of the Service is
                      conditioned on Your acceptance of and compliance with
                      these Terms and Conditions. These Terms and Conditions
                      apply to all visitors, users and others who access or use
                      the Service. By accessing or using the Service You agree
                      to be bound by these Terms and Conditions. If You disagree
                      with any part of these Terms and Conditions then You may
                      not access the Service. You represent that you are over
                      the age of 18. The Company does not permit those under 18
                      to use the Service. Your access to and use of the Service
                      is also conditioned on Your acceptance of and compliance
                      with the Privacy Policy of the Company. Our Privacy Policy
                      describes Our policies and procedures on the collection,
                      use and disclosure of Your personal information when You
                      use the Application or the Website and tells You about
                      Your privacy rights and how the law protects You. Please
                      read Our Privacy Policy carefully before using Our
                      Service.
                    </p>
                  </div>
                </div>

                <div className="flex  mt-2 items-center">
                  <div className=" w-full ">
                    <h2 className=" mb-4  font-[700] mt-4">User Accounts</h2>
                    <p classname="text-sm my-2">
                      When You create an account with Us, You must provide Us
                      information that is accurate, complete, and current at all
                      times. Failure to do so constitutes a breach of the Terms,
                      which may result in immediate termination of Your account
                      on Our Service.
                    </p>
                    <p classname="text-sm my-2">
                      You are responsible for safeguarding the password that You
                      use to access the Service and for any activities or
                      actions under Your password, whether Your password is with
                      Our Service or a Third-Party Social Media Service.
                    </p>
                    <p classname="text-sm my-2">
                      You agree not to disclose Your password to any third
                      party. You must notify Us immediately upon becoming aware
                      of any breach of security or unauthorized use of Your
                      account.
                    </p>
                    <p classname="text-sm my-2">
                      You may not use as a username the name of another person
                      or entity or that is not lawfully available for use, a
                      name or trademark that is subject to any rights of another
                      person or entity other than You without appropriate
                      authorization, or a name that is otherwise offensive,
                      vulgar or obscene.
                    </p>
                  </div>
                </div>

                <div className="flex  mt-2  items-center">
                  <div className=" w-full  ">
                    <h2 className=" mb-4  font-[700] mt-4">Content</h2>
                    <p classname="text-smtext-xl my-2">
                      Your Right to Post Content
                    </p>
                    <p classname="text-sm my-2">
                      Our Service allows You to post Content. You are
                      responsible for the Content that You post to the Service,
                      including its legality, reliability, and appropriateness.
                    </p>
                    <p classname="text-sm my-2">
                      By posting Content to the Service, You grant Us the right
                      and license to use, modify, publicly perform, publicly
                      display, reproduce, and distribute such Content on and
                      through the Service. You retain any and all of Your rights
                      to any Content You submit, post or display on or through
                      the Service and You are responsible for protecting those
                      rights. You agree that this license includes the right for
                      Us to make Your Content available to other users of the
                      Service, who may also use Your Content subject to these
                      Terms.
                    </p>
                    <p classname="text-sm my-2">
                      You represent and warrant that: (i) the Content is Yours
                      (You own it) or You have the right to use it and grant Us
                      the rights and license as provided in these Terms, and
                      (ii) the posting of Your Content on or through the Service
                      does not violate the privacy rights, publicity rights,
                      copyrights, contract rights or any other rights of any
                      person.
                    </p>
                  </div>
                </div>

                <div className="flex  mt-2  items-center">
                  <div className=" w-full ">
                    <h2 className=" mb-4  font-[700] mt-4">
                      Content Restrictions
                    </h2>
                    <p classname="text-sm my-2">
                      The Company is not responsible for the content of the
                      Service's users. You expressly understand and agree that
                      You are solely responsible for the Content and for all
                      activity that occurs under your account, whether done so
                      by You or any third person using Your account. You may not
                      transmit any Content that is unlawful, offensive,
                      upsetting, intended to disgust, threatening, libelous,
                      defamatory, obscene or otherwise objectionable.
                    </p>
                    Examples of such objectionable Content include, but are not
                    limited to, the following:
                    <ul className="flex flex-col items-start w-full mt-4">
                      <li className=" my-2">
                        1.Unlawful or promoting unlawful activity.
                      </li>
                      <li className=" my-2">
                        2. Defamatory, discriminatory, or mean-spirited content,
                        including references or commentary about religion, race,
                        sexual orientation, gender, national/ethnic origin, or
                        other targeted groups.
                      </li>
                      <li className=" my-2">
                        3.Spam, machine – or randomly – generated, constituting
                        unauthorized or unsolicited advertising, chain letters,
                        any other form of unauthorized solicitation, or any form
                        of lottery or gambling.
                      </li>
                      <li className=" my-2">
                        4.Containing or installing any viruses, worms, malware,
                        trojan horses, or other content that is designed or
                        intended to disrupt, damage, or limit the functioning of
                        any software, hardware or telecommunications equipment
                        or to damage or obtain unauthorized access to any data
                        or other information of a third person.
                      </li>
                      <li className=" my-2">
                        5.Infringing on any proprietary rights of any party,
                        including patent, trademark, trade secret, copyright,
                        right of publicity or other rights.
                      </li>
                      <li className=" my-2">
                        6.Impersonating any person or entity including the
                        Company and its employees or representatives.
                      </li>
                      <li className=" my-2">
                        7.Violating the privacy of any third person.
                      </li>
                      <li className=" my-2">
                        8.False information and features.
                      </li>
                    </ul>
                  </div>
                </div>

                <div>
                  <p>
                    The Company reserves the right, but not the obligation, to,
                    in its sole discretion, determine whether or not any Content
                    is appropriate and complies with this Terms, refuse or
                    remove this Content. The Company further reserves the right
                    to make formatting and edits and change the manner of any
                    Content. The Company can also limit or revoke the use of the
                    Service if You post such objectionable Content.
                    <br />
                    As the Company cannot control all content posted by users
                    and/or third parties on the Service, you agree to use the
                    Service at your own risk. You understand that by using the
                    Service You may be exposed to content that You may find
                    offensive, indecent, incorrect or objectionable, and You
                    agree that under no circumstances will the Company be liable
                    in any way for any content, including any errors or
                    omissions in any content, or any loss or damage of any kind
                    incurred as a result of your use of any content.
                  </p>
                </div>

                <div className="flex  mt-2  items-center">
                  <div className=" w-full  ">
                    <h2 className=" mb-4   font-[700] mt-4">Content Backups</h2>
                    <p classname="text-sm my-2">
                      Although regular backups of Content are performed, the
                      Company does not guarantee there will be no loss or
                      corruption of data.
                    </p>
                    <p classname="text-sm my-2">
                      Corrupt or invalid backup points may be caused by, without
                      limitation, Content that is corrupted prior to being
                      backed up or that changes during the time a backup is
                      performed.
                    </p>
                    <p classname="text-sm my-2">
                      The Company will provide support and attempt to
                      troubleshoot any known or discovered issues that may
                      affect the backups of Content. But You acknowledge that
                      the Company has no liability related to the integrity of
                      Content or the failure to successfully restore Content to
                      a usable state.
                    </p>
                    <p classname="text-sm my-2">
                      You agree to maintain a complete and accurate copy of any
                      Content in a location independent of the Service.
                    </p>
                    <h2 classname="font-[700]  mt-4">Copyright Policy</h2>
                    <p classname="text-sm my-2">
                      We respect the intellectual property rights of others. It
                      is Our policy to respond to any claim that Content posted
                      on the Service infringes a copyright or other intellectual
                      property infringement of any person.
                    </p>
                    <p classname="text-sm my-2">
                      If You are a copyright owner, or authorized on behalf of
                      one, and You believe that the copyrighted work has been
                      copied in a way that constitutes copyright infringement
                      that is taking place through the Service, You must submit
                      Your notice in writing to the attention of our copyright
                      agent via email info@fuelcab.com and include in Your
                      notice a detailed description of the alleged infringement.
                    </p>
                    <p classname="text-sm my-2">
                      You may be held accountable for damages (including costs
                      and attorneys' fees) for misrepresenting that any Content
                      is infringing Your copyright.
                    </p>
                  </div>
                </div>

                <div className="flex  mt-2  items-center">
                  <div className=" w-full ">
                    <h2 className=" mb-4  font-[700] my-4 ">
                      DMCA Notice and DMCA Procedure for Copyright Infringement
                      Claims
                    </h2>
                    <p classname="text-sm my-2">
                      You may submit a notification pursuant to the Digital
                      Millennium Copyright Act (DMCA) by providing our Copyright
                      Agent with the following information in writing (see 17
                      U.S.C 512(c)(3) for further detail):
                    </p>
                    <ul className="flex flex-col items-start w-full mt-4">
                      <li className=" my-2">
                        1. An electronic or physical signature of the person
                        authorized to act on behalf of the owner of the
                        copyright's interest.
                      </li>
                      <li className=" my-2">
                        2.A description of the copyrighted work that You claim
                        has been infringed, including the URL (i.e., web page
                        address) of the location where the copyrighted work
                        exists or a copy of the copyrighted work.
                      </li>
                      <li className=" my-2">
                        3.Identification of the URL or other specific location
                        on the Service where the material that You claim is
                        infringing is located.
                      </li>
                      <li className=" my-2">
                        4.Your address, telephone number, and email address.
                      </li>
                      <li className=" my-2">
                        5.A statement by You that You have a good faith belief
                        that the disputed use is not authorized by the copyright
                        owner, its agent, or the law.
                      </li>
                      <li className=" my-2">
                        6. A statement by You, made under penalty of perjury,
                        that the above information in Your notice is accurate
                        and that You are the copyright owner or authorized to
                        act on the copyright owner's behalf.
                      </li>
                    </ul>
                    <p classname="text-sm my-2">
                      You can contact our copyright agent via email
                      info@fuelcab.com . Upon receipt of a notification, the
                      Company will take whatever action, in its sole discretion,
                      it deems appropriate, including removal of the challenged
                      content from the Service.
                    </p>
                  </div>
                </div>

                <div className="flex  mt-2    items-center">
                  <div className=" w-full  ">
                    <h2 className=" mb-4  font-[700]  my-4">
                      Intellectual Property
                    </h2>
                    <p classname="text-sm my-2">
                      The Service and its original content (excluding Content
                      provided by You or other users), features and
                      functionality are and will remain the exclusive property
                      of the Company and its licensors.
                    </p>
                    <p classname="text-sm my-2">
                      The Service is protected by copyright, trademark, and
                      other laws of both the Country and foreign countries.
                    </p>
                    <p classname="text-sm my-2">
                      Our trademarks and trade dress may not be used in
                      connection with any product or service without the prior
                      written consent of the Company.
                    </p>
                    <h2 className=" my-2">Your Feedback to Us</h2>
                    <p classname="text-sm my-2">
                      You assign all rights, title and interest in any Feedback
                      You provide the Company. If for any reason such assignment
                      is ineffective, You agree to grant the Company a
                      non-exclusive, perpetual, irrevocable, royalty free,
                      worldwide right and license to use, reproduce, disclose,
                      sub-license, distribute, modify and exploit such Feedback
                      without restriction.
                    </p>
                    <h2 className="  my-2">Links to Other Websites</h2>
                    <p classname="text-sm my-2">
                      Our Service may contain links to third-party web sites or
                      services that are not owned or controlled by the Company.
                    </p>
                    <p classname="text-sm my-2">
                      The Company has no control over, and assumes no
                      responsibility for, the content, privacy policies, or
                      practices of any third party web sites or services. You
                      further acknowledge and agree that the Company shall not
                      be responsible or liable, directly or indirectly, for any
                      damage or loss caused or alleged to be caused by or in
                      connection with the use of or reliance on any such
                      content, goods or services available on or through any
                      such web sites or services.
                    </p>
                    <p classname="text-sm my-2">
                      We strongly advise You to read the terms and conditions
                      and privacy policies of any third-party web sites or
                      services that You visit.
                    </p>
                    <h2 className=" my-2">Termination</h2>
                    <p classname="text-sm my-2">
                      We may terminate or suspend Your Account immediately,
                      without prior notice or liability, for any reason
                      whatsoever, including without limitation if You breach
                      these Terms and Conditions.
                    </p>
                    <p classname="text-sm my-2">
                      Upon termination, Your right to use the Service will cease
                      immediately. If You wish to terminate Your Account, You
                      may simply discontinue using the Service.
                    </p>
                  </div>
                </div>

                <div className="flex  mt-2  items-center">
                  <div className=" w-full ">
                    <h2 className=" mb-4   my-4 font-[700]">
                      "AS IS" and "AS AVAILABLE" Disclaimer
                    </h2>
                    <p classname="text-sm my-2">
                      The Service is provided to You "AS IS" and "AS AVAILABLE"
                      and with all faults and defects without warranty of any
                      kind. To the maximum extent permitted under applicable
                      law, the Company, on its own behalf and on behalf of its
                      Affiliates and its and their respective licensors and
                      service providers, expressly disclaims all warranties,
                      whether express, implied, statutory or otherwise, with
                      respect to the Service, including all implied warranties
                      of merchantability, fitness for a particular purpose,
                      title and non-infringement, and warranties that may arise
                      out of course of dealing, course of performance, usage or
                      trade practice. Without limitation to the foregoing, the
                      Company provides no warranty or undertaking, and makes no
                      representation of any kind that the Service will meet Your
                      requirements, achieve any intended results, be compatible
                      or work with any other software, applications, systems or
                      services, operate without interruption, meet any
                      performance or reliability standards or be error free or
                      that any errors or defects can or will be corrected.
                    </p>
                    <p classname="text-sm my-2">
                      Some jurisdictions do not allow the exclusion of certain
                      types of warranties or limitations on applicable statutory
                      rights of a consumer, so some or all of the above
                      exclusions and limitations may not apply to You. But in
                      such a case the exclusions and limitations set forth in
                      this section shall be applied to the greatest extent
                      enforceable under applicable law.
                    </p>
                  </div>
                </div>

                <div className="flex  mt-2  items-center">
                  <div className=" w-full  ">
                    <h2 className=" mb-4   font-[700] my-4">Governing Law</h2>
                    <p classname="text-sm my-2">
                      The laws of the Country, excluding its conflicts of law
                      rules, shall govern this Terms and Your use of the
                      Service. Your use of the Application may also be subject
                      to other local, state, national, or international laws.
                    </p>
                  </div>
                </div>
                <div className="flex mb-6 items-center">
                  <div className=" w-full ">
                    <h2 className=" mb-4  font-[700] my-4 ">
                      Changes to These Terms and Conditions
                    </h2>
                    <p classname="text-sm my-2">
                      We reserve the right, at Our sole discretion, to modify or
                      replace these Terms at any time. If a revision is material
                      We will make reasonable efforts to provide at least 30
                      days' notice prior to any new terms taking effect. What
                      constitutes a material change will be determined at Our
                      sole discretion.
                    </p>
                    <p classname="text-sm my-2">
                      By continuing to access or use Our Service after those
                      revisions become effective, You agree to be bound by the
                      revised terms. If You do not agree to the new terms, in
                      whole or in part, please stop using the website and the
                      Service.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default TermPolicy;
